import { render } from "./AnnotationCanvas.vue?vue&type=template&id=ed36499a&scoped=true"
import script from "./AnnotationCanvas.vue?vue&type=script&lang=js"
export * from "./AnnotationCanvas.vue?vue&type=script&lang=js"

import "./AnnotationCanvas.vue?vue&type=style&index=0&id=ed36499a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed36499a"]])

export default __exports__